/**
 * A barra fina de participação de uma categoria no total.
 *
 * Papel: reproduz `.progress-bar` e `.progress-fill` (l. 145–146) com a margem
 * que `renderCatTable` põe por `style` (l. 2640): 6 px de altura, trilho bege,
 * raio de 4 px e o preenchimento na cor da categoria, com a transição de
 * largura de 0,4 s.
 *
 * Como usar: `cor` é a cor da categoria, que é **dado** gravado no plano de
 * contas e por isso entra por `style`, e não por classe. A categoria sem cor
 * recebe `var(--emb-cinza-texto)` de quem chama, que é o cinza de reserva da
 * origem. O percentual acima de 100 não estoura o trilho, porque o trilho
 * esconde o que sobra.
 */

interface BarraDeProgressoProps {
  /** A parte do total, de 0 a 100. */
  percentual: number;
  /** A cor do preenchimento: `#rrggbb` do plano ou uma `var(--token)`. */
  cor: string;
}

/**
 * A barra de participação.
 *
 * @param percentual - A largura do preenchimento, em percentual.
 * @param cor - A cor do preenchimento.
 * @returns O trilho com o preenchimento.
 */
export function BarraDeProgresso({ percentual, cor }: BarraDeProgressoProps) {
  return (
    <div className="mt-1.5 mb-1 h-1.5 overflow-hidden rounded-[4px] bg-emb-borda">
      <div
        className="h-full rounded-[4px] transition-[width] duration-[400ms]"
        style={{ width: `${percentual.toFixed(1)}%`, background: cor }}
      />
    </div>
  );
}
